import { render, staticRenderFns } from "./RamoAhorroComponent.vue?vue&type=template&id=04b67408"
import script from "./RamoAhorroComponent.vue?vue&type=script&lang=js"
export * from "./RamoAhorroComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports